export const AppMinimVersion = 'app-minimum-version';

export const AppMinimVersionView = `/${AppMinimVersion}`;
